import { memo } from 'react';

interface CheckboxFieldProps {
    id: string;
    label: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled: boolean;
}

export const CheckboxField = memo(({
    id,
    label,
    checked,
    onChange,
    disabled
}: CheckboxFieldProps) => {
    return (
        <div className="input-group input-group-checkbox">
            <label htmlFor={id}>{label}</label>
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
        </div>
    );
});
